import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Collapse,
  CircularProgress,
  Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { Country, State } from "country-state-city";
import {
  FETCH_COLLABORATOR_TYPE_LOADING,
  FETCH_NETWORK_TYPES_LOADING,
  GET_NETWORK_ROLES_LOADING,
} from "../../../../containers/actions/types";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {
  fetchCollaboratorType,
  fetchNetworkType,
  getNetworkRoles,
} from "../../../../containers/actions/netwrokActions";
import { useDispatch, useSelector } from "react-redux";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SponsorNetworkList from "./SponsorNetworkList";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  table: {
    maxWidth: 650,
    border: "1px solid #e0e0e0",
    marginTop: 10,
  },
  smallCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  headerCell: {
    padding: "6px 8px",
    fontSize: "0.875rem",
  },
  bodyCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },

    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
    marginBottom: "4px",
    marginTop: "4px",
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const ReviewEcosystem = (props) => {
  const { hideActions, handleBack, handleSendInvitation, isLoading, ...otherProps } =
    props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    sponsorDetails,
    adminDetails,
    // networkTypes,
    networkURL,
    selectedIndices,
    addSponsorList,
    rowData,
    rowNetwork,
    updateNetworkData,
    // ecosystemDetails,
    // manufacturingSlotNumberingDetails,
    // therapyParameters,
    // therapyStepDurationAfterChanges,
    // rolesAndTypesData,
    existingSponsorFlow,
  } = otherProps;
  const [openRows, setOpenRows] = useState({});
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [modalities, setModalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
    const [networkTypes, setNetworkTypes] = useState([]);

const ecosystemURL=updateNetworkData?.ecosystemUrl || rowData?.networkURL;
const network=addSponsorList?.data?.network || rowNetwork;

  const initialPartnerTypes = useSelector(
    (state) => state?.network?.partnerDetails || []
  );
  // console.log("initialNetworkTypes",initialNetworkTypes)
  // console.log("initialPartnerTypes",initialPartnerTypes)

  const initialPartnerTypesLoading = useSelector(
    (state) => state?.network?.partnerDetailsTypeLoading || []
  );

      const initialNetworkTypes = useSelector(
        (state) => state?.network?.networkDetails || []
      );
    
      // console.log("networkUrl",networkURL)
      const initialNetworkTypesLoading = useSelector(
        (state) => state?.network?.fetchNetworkTypeLoading || []
      );
console.log("rowData",rowData);
console.log("addSponsorlist",addSponsorList);
console.log("sponsorDetails",sponsorDetails);

          useEffect(() => {
            dispatch({
              type: FETCH_NETWORK_TYPES_LOADING,
              payload: true,
            });
        
            // if (addSponsorList?.data) {
            //   dispatch(fetchNetworkType(addSponsorList?.data?.ecosystemId));
            // }
              if (rowData?.status === "Pending" && rowData?.ecosystemId &&
                (Array.isArray(addSponsorList) && addSponsorList.length === 0)
              ) {
                dispatch(fetchNetworkType(rowData.ecosystemId));
              } else if (addSponsorList?.data?.ecosystemId) {
                dispatch(fetchNetworkType(addSponsorList.data.ecosystemId));
              }
          }, [addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.status]);
  
        useEffect(() => {
          if (
            initialNetworkTypes?.NetworkTypes &&
            initialNetworkTypes?.NetworkTypes.length > 0
          ) {
            const types = initialNetworkTypes.NetworkTypes;
            setNetworkTypes(types);
      
            // Find and set the active network type
          }
        }, [initialNetworkTypes]);

  useEffect(() => {
    dispatch({
      type: FETCH_COLLABORATOR_TYPE_LOADING,
      payload: true,
    });
    // dispatch(fetchCollaboratorType());
          //   if (addSponsorList?.data) {
          // dispatch(fetchCollaboratorType(addSponsorList?.data?.ecosystemId));
          //   }

                    if (rowData?.status === "Pending" && rowData?.ecosystemId &&
                      (Array.isArray(addSponsorList) && addSponsorList.length === 0)
                    ) {
                      dispatch(fetchCollaboratorType(rowData.ecosystemId));
                    } else if (addSponsorList?.data?.ecosystemId) {
                      dispatch(fetchCollaboratorType(addSponsorList.data.ecosystemId));
                    }
  }, [addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.status]);

  useEffect(() => {
    if (initialPartnerTypes && initialPartnerTypes?.data?.length > 0) {
      setPartnerTypes(initialPartnerTypes?.data);
    }
  }, [initialPartnerTypes]);

  const getRoles = useSelector((state) => state?.network?.getAllRoles || []);

  const getRolesLoading = useSelector(
    (state) => state?.network?.getAllRolesLoading
  );

  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  const fetchProductModalities = async () => {
    setLoading(true);
    setError(null); // Reset error state before new fetch

    // Open backdrop before API call
    dispatch({
      type: OPEN_BACKDROP,
    });

    try {
      const url = `${ecosystemURL}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantDrugTypes/false`;

      const response = await axios.get(url);

      const drugTypeList = response.data?.data?.drugTypeList || [];

      const formatted = drugTypeList.map((item, index) => ({
        ...item,
        id: item.drugTypeID || `ID-${index + 1}`,
        name: item.drugTypeName || "",
        selected: !!item.activated,
        isNew: false,
      }));

      setModalities(formatted);
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      // Always close backdrop and stop loading
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if(network && ecosystemURL){
      fetchProductModalities(setModalities, setLoading);
    }
  }, [network, ecosystemURL]);
 const networkEcosystemUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL
  const getNetworkValue = rowNetwork || addSponsorList?.data?.network || rowData?.network
  useEffect(() => {
    dispatch({
      type: GET_NETWORK_ROLES_LOADING,
      payload: true,
    });
  //  dispatch(
  //     getNetworkRoles({
  //       ecosystemId:addSponsorList?.data?.ecosystemId,
  //     })
  //   );
 
   
   
      if (rowData?.ecosystemId && rowNetwork && rowData?.networkURL &&
        (Array.isArray(addSponsorList) && addSponsorList.length === 0)
      ) {
        dispatch(getNetworkRoles({
          ecosystemId:rowData?.ecosystemId,
           network:getNetworkValue,
           ecosystemUrl:networkEcosystemUrl,
        }));
      } else if (addSponsorList?.data?.ecosystemId) {
        dispatch(getNetworkRoles({
          ecosystemId :addSponsorList.data.ecosystemId,
         network:getNetworkValue,
         ecosystemUrl:networkEcosystemUrl
        }));
      }
  }, [addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, ,rowData?.status,getNetworkValue,networkEcosystemUrl]);

  const handleRowClick = (id) => {
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [id]: !prevOpenRows[id],
    }));
  };
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Sponsor Details
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Sponsor Name
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails?.sponsorName}
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={6}></Grid> */}
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Sponsor Short Name
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails?.sponsorNameShortcut}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Street Address 1
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails.streetAddress1}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Street Address 2
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails.streetAddress2}
          </Typography>
        </Grid>

       

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Country
          </Typography>
          {existingSponsorFlow ? (
            <Typography className={classes.textfieldWidth}>
              {sponsorDetails.selectedCountry}
            </Typography>
          ) : (
            <Typography className={classes.textfieldWidth}>
              {Country.getAllCountries().find(
                (country) => country.isoCode === sponsorDetails.selectedCountry
              )?.name ?? "Country not found."}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            State
          </Typography>
          {existingSponsorFlow ? (
            <Typography className={classes.textfieldWidth}>
              {sponsorDetails.selectedState}
            </Typography>
          ) : (
            <Typography className={classes.textfieldWidth}>
              {State.getStatesOfCountry(sponsorDetails.selectedCountry).find(
                (state) => state.isoCode === sponsorDetails.selectedState
              )?.name ?? "State not found."}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            City
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails.selectedCity}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Post Code
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails.postCode}
          </Typography>
        </Grid>

        

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Status
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails.selectedStatus}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Organization Code
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {sponsorDetails?.orgCode || rowData?.organizationCode || "NA"}
            {/* {addSponsorList?.data?.organizationCode || "NA"} */}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={11}>
          <hr className={classes.hr} />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Admin Details
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Full Name
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {adminDetails?.fullName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Email Address
          </Typography>
          <Typography className={classes.textfieldWidth}>
            {adminDetails?.emailAddress}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body1"
            style={{ fontWeight: "bold", marginBottom: "8px" }}
          >
            Phone
          </Typography>

          <Typography className={classes.textfieldWidth}>
            +{adminDetails?.phone}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={11}>
          <hr className={classes.hr} />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" className={classes.inline}>
          Network Details
        </Typography>
        <hr className={classes.hrLine} />
      </Grid>

      {/* <Table style={{ marginTop: "2rem" }} className={classes.table}>
        <TableHead style={{ backgroundColor: "#F9F9FC" }}>
          <TableRow>
            <TableCell className={classes.smallCell}>Selection</TableCell>
            <TableCell className={classes.smallCell}>Network Type</TableCell>
            <TableCell align="right" className={classes.smallCell}>
              Network Type ID
            </TableCell>
          </TableRow>
        </TableHead>
        {networkTypes?.length > 0 ? (
          <TableBody>
            {networkTypes.map((item, index) => (
              <TableRow key={index}>
                <TableCell className={classes.smallCell}>
                  <input
                    type="radio"
                    style={{
                      width: "1rem",
                      height: "1rem",
                      accentColor: "#EC6535",
                    }}
                    //  checked={selectedIndices === index}
                    checked={item.activated === true}
                    //  onChange={() => handleCheckboxChange(index)}
                  />
                </TableCell>
                <TableCell className={classes.smallCell}>
                  <Typography variant="body2">{item.networkType}</Typography>
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  {item.display_id !== null && item.display_id !== undefined
                    ? item.display_id < 10
                      ? `0${item.display_id}`
                      : item.display_id
                    : item.ecosystem_type_id < 10
                    ? `0${item.ecosystem_type_id}`
                    : item.ecosystem_type_id}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
             </Table> */}

                                   <Table style={{ marginTop: "2rem" }} className={classes.table}>
                         <TableHead style={{ backgroundColor: "#F9F9FC" }}>
                           <TableRow>
                             <TableCell className={classes.smallCell}>Selection</TableCell>
                             <TableCell className={classes.smallCell}>
                               Network Type
                             </TableCell>
                             <TableCell align="right" className={classes.smallCell}>
                               Network Type ID
                             </TableCell>
                              </TableRow>
                         </TableHead>
                         {initialNetworkTypesLoading === true ? (
                           <TableRow style={{ height: 150 }}>
                             <TableCell colSpan={12}>
                               <div style={{ textAlign: "center" }}>
                                 <CircularProgress color="primary" thickness={7} />
                               </div>
                             </TableCell>
                           </TableRow>
                         ) : networkTypes.length > 0 ? (
                           <TableBody>
                             {networkTypes.map((item, index) => (
                               <TableRow key={index}>
                                 <TableCell className={classes.smallCell}>
                                   {/* <input
                                   type="radio"
                                   style={{ width: '1rem', height: '1rem' }}
                                    checked={selectedIndices.includes(index)}
                                   onChange={() => handleCheckboxChange(index)}
                                 /> */}
                                   <input
                                     type="radio"
                                     style={{
                                       width: "1rem",
                                       height: "1rem",
                                       accentColor: "#EC6535",
                                     }}
                                     //  checked={selectedIndices === index}
                                     checked={item.activated === true}
                                     // onChange={() => handleCheckboxChange(index)}
                                     disabled={item.isNew}
                                   />
                                 </TableCell>
                                 <TableCell className={classes.smallCell}>
                
                                     <Typography variant="body2">
                                       {item.networkType}
                                     </Typography>
                                
                                 </TableCell>
                                 <TableCell align="right" className={classes.smallCell}>
                                   {/* {item.networkTypeID} */}
                                   {/* {item.display_id < 10 ? `0${item.display_id}` : item.display_id}
                                    */}
             
                                   {item.display_id !== null && item.display_id !== undefined
                                     ? item.display_id < 10
                                       ? `0${item.display_id}`
                                       : item.display_id
                                     : item.ecosystem_type_id < 10
                                     ? `0${item.ecosystem_type_id}`
                                     : item.ecosystem_type_id}
                                 </TableCell>
                               </TableRow>
                             ))}
                           </TableBody>
                         ) : initialNetworkTypes?.status === false ? (
                           <TableRow
                             style={{
                               border: "2px solid rgb(255,0,0)",
                               backgroundColor: "rgb(255,240,240)",
                               Opacity: 1,
                               textAlign: "center",
                               padding: "0.8rem",
                               fontSize: "0.875rem",
                             }}
                           >
                             <TableCell colSpan={10} align="center">
                               {"Something went wrong. Please contact Schrocken Support."}
                             </TableCell>
                           </TableRow>
                         ) : (
                           <TableRow>
                             <TableCell colSpan={9} align="center">
                               No records found
                             </TableCell>
                           </TableRow>
                         )}
                       </Table>  

      <Grid style={{ marginTop: "1.5rem" }}>
        <Typography style={{ fontWeight: "bold" }}>Network URL</Typography>
        <Typography>{networkURL}</Typography>
      </Grid>

      <Table style={{ marginTop: "2rem" }} className={classes.table}>
        <TableHead style={{ backgroundColor: "#F9F9FC" }}>
          <TableRow>
            <TableCell className={classes.smallCell}>Selection</TableCell>
            <TableCell className={classes.smallCell}>Partner Types</TableCell>
            <TableCell align="right" className={classes.smallCell}>
              Partner Type ID
            </TableCell>
          </TableRow>
        </TableHead>
        {initialPartnerTypesLoading === true ? (
          <TableRow style={{ height: 150 }}>
            <TableCell colSpan={12}>
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" thickness={7} />
              </div>
            </TableCell>
          </TableRow>
        ) : partnerTypes?.length > 0 ? (
          <TableBody>
            {partnerTypes.map((item, index) => (
              <TableRow key={index}>
                <TableCell className={classes.smallCell}>
                  {/* <Switch
                                              classes={{ root: classes.root }}
                                              checked={selectedIndices.includes(index) || item.activated === true}
                                              onChange={() => handleCheckboxChange(index)}
                                              disabled={item.isNew} 
                                            />                 */}

                  <Switch
                    classes={{ root: classes.root }}
                    checked={item.activated}
                    // onChange={() => handleCheckboxChange(index)}
                    // disabled={item.isNew}
                  />
                </TableCell>
                <TableCell className={classes.smallCell}>
                  <Typography variant="body2">
                    {item.collaborator_type_name}
                  </Typography>
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  {item?.collaborator_type_id || "NA"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : initialPartnerTypes?.status === false ? (
          <TableRow
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            <TableCell colSpan={10} align="center">
              {"Something went wrong. Please contact Schrocken Support."}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
      </Table>

      <div style={{marginTop:"2rem"}}>
                        <div style={{ display: 'flex', gap: '4rem',flexDirection:"row",lineHeight:"2rem"}}>
                     
                <div>
                <table border="1" style={{borderCollapse:"collapse"}} cellPadding={6} >
                        <thead style={{backgroundColor:"#F9F9FC",lineHeight:"1.5rem"}}>
                          <tr style={{border:"1px solid black"}}>
                            <th style={{border:"none"}} align='left'>Sponsor Role</th>
                            <th style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>Sponsor<br/> Role ID</th>
                          </tr>
                        </thead>
                {getRolesLoading === true ?(
                                              <tr style={{ height: 150 }}>
                                              <td colSpan={12}>
                                                <div style={{ textAlign: "center" }}>
                                                  <CircularProgress color="primary" thickness={7} />
                                                </div>
                                              </td>
                                            </tr>
                            ) : getRoles?.data?.sponsorRoles.length > 0 ? (
                              <tbody>
                              {getRoles?.data?.sponsorRoles.map((role, index) => (
                                <tr style={{border:"1px solid black"}} key={index}>
                                  <td style={{border:"none"}} align='left'>{role.role_name}</td>
                                  <td style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>{role.collaborator_role_id}</td>
                                </tr>
                              ))}
                            </tbody>
                            ) : getRoles?.status === false ? (
                              <tr
                              style={{
                                border: "2px solid rgb(255,0,0)",
                                backgroundColor: "rgb(255,240,240)",
                                Opacity: 1,
                                textAlign: "center",
                                padding: "0.8rem",
                                fontSize: "0.875rem",
                              }}>
                                <td align='center'>
                                {"Something went wrong. Please contact Schrocken Support."}
                                </td>
                              </tr>
                            ) : (
                                 <tr>
                                            <td colSpan={9} align="center">
                                              No records found
                                            </td>
                                          </tr>
                            ) }
                
                
                      </table>
                </div>
                
                    
                <div>
                <table border="1" style={{borderCollapse:"collapse"}} cellPadding={6}>
                        <thead style={{backgroundColor:"#F9F9FC",lineHeight:"1.5rem"}}>
                          <tr style={{border:"1px solid black"}} >
                            <th style={{border:"none"}} align='left'>CMO Role</th>
                            <th style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>CMO <br/> Role ID</th>
                          </tr>
                        </thead>
                        {getRolesLoading === true ?(
                                              <tr style={{ height: 150 }}>
                                              <td colSpan={12}>
                                                <div style={{ textAlign: "center" }}>
                                                  <CircularProgress color="primary" thickness={7} />
                                                </div>
                                              </td>
                                            </tr>
                            ) : getRoles?.data?.cmoRoles.length > 0 ? (
                              <tbody>
                              {getRoles?.data?.cmoRoles.map((role,index) => (
                                <tr style={{border:"1px solid black"}} key={index}>
                                  <td style={{border:"none"}} align='left'>{role.role_name}</td>
                                  <td style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>{role.collaborator_role_id}</td>
                                </tr>
                              ))}
                            </tbody>
                            ) : getRoles?.status === false ? (
                              <tr
                              style={{
                                border: "2px solid rgb(255,0,0)",
                                backgroundColor: "rgb(255,240,240)",
                                Opacity: 1,
                                textAlign: "center",
                                padding: "0.8rem",
                                fontSize: "0.875rem",
                              }}>
                                <td align='center'>
                                {"Something went wrong. Please contact Schrocken Support."}
                                </td>
                              </tr>
                            ) : (
                                 <tr>
                                            <td colSpan={9} align="center">
                                              No records found
                                            </td>
                                          </tr>
                            ) }
                      </table>
                </div>
                
                
                    </div>
                
                                          </div>

      <Grid item xs={12} style={{ marginTop: "2rem" }}>
        <Typography variant="body2" className={classes.inline}>
          Sponsor Network Configurations
        </Typography>
        <hr className={classes.hrLine} />
      </Grid>
      {/* *************Product Modality*************** */}

      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>
              Product Modality
            </TableCell>
            <TableCell className={classes.headerCell}>
              Product Modality ID
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    border: "2px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                    width: "100%",
                  }}
                >
                  <Typography style={{ textAlign: "center" }}>
                    {error}
                  </Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            modalities.map((modality, index) => (
              <TableRow key={modality.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={modality.selected}
                    // onChange={() => handleToggle(index)}
                    // onChange={() => handleToggleModality(modality.id)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {modality?.name}
                </TableCell>

                <TableCell className={classes.bodyCell}>
                  {modality.id}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      <SponsorNetworkList
    addSponsorList={addSponsorList}
    rowData={rowData}
    rowNetwork={rowNetwork}
    updateNetworkData={updateNetworkData} 
    />

      {!hideActions && (
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "30px",
              marginBottom: "30px",
            }}
          >
                    <Grid
                      className={classes.backButton}
                  onClick={handleBack}
                    >
                      <ChevronLeftIcon />
                      Back
                    </Grid>
          <Grid
          className={classes.saveButton}
          onClick={handleSendInvitation}
          disabled={isLoading}
        >
         {isLoading ? 'Sending...' : 'Send Invitation'}
         {isLoading ? <CircularProgress size={20} color="inherit" /> : <ChevronRightIcon />}
           </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ReviewEcosystem;
